{
  "apiKey": "AIzaSyDdo6CtBkirOqPd0XfT4mbWBDCn3N3QEhk",
  "authDomain": "automatarium-dev.firebaseapp.com",
  "projectId": "automatarium-dev",
  "storageBucket": "automatarium-dev.appspot.com",
  "messagingSenderId": "1007726941830",
  "appId": "1:1007726941830:web:d4ee6a5d56853d1b4f6307"
}